import * as React from 'react';
import Layout from './src/components/Layout';
import Transition from './src/components/Transition';
import ReduxWrapper from './src/components/ReduxWrapper';
import { PersonalizationProvider } from './src/components/Personalization/PersonalizationContext';
import PersonalizationTrigger from './src/components/Personalization/PersonalizationTrigger';
import { HeadContext } from './src/components/Head/HeadContext';

// export const wrapRootElement = ReduxWrapper;

export const wrapRootElement = (props) => {
	return (
		<PersonalizationProvider {...props}>
			<PersonalizationTrigger {...props}>
				<ReduxWrapper {...props}>
					<HeadContext {...props} />
				</ReduxWrapper>
			</PersonalizationTrigger>
		</PersonalizationProvider>
	)
}

export const onClientEntry = () => {
	// IntersectionObserver polyfill for gatsby-background-image (Safari, IE)
	if (!(`IntersectionObserver` in window)) {
		return import(`intersection-observer`)
	}
	document.addEventListener('click', (evt) => {
		window.dataLayer = window.dataLayer || [];
		let counter = 1;
		for (const item of window.dataLayer) {
			if (item.session_interaction_counter !== undefined)counter = Math.max(counter, item.session_interaction_counter+1);
		}
		window.dataLayer.push({
			event: 'session_interaction_counter',
			session_interaction_counter: counter,
		});
	});
}

export const wrapPageElement = ({element, props}) => {
	//console.log(`Browser: `, props)
	return (
		<Layout {...props}>
			<Transition {...props}>
				{element}
			</Transition>
		</Layout>
	)
}

export const onRouteUpdate = ({location, prevLocation}) => {
	window.dataLayer = window.dataLayer || [];
	let sessionInteractionCounter = 0;
	let categoryInteractionCounter = 0;
	for (const item of window.dataLayer) {
		sessionInteractionCounter = Math.max(sessionInteractionCounter, item.session_interaction_counter||0);
		categoryInteractionCounter = Math.max(categoryInteractionCounter, item.category_interaction_counter||0);
	}
	window.dataLayer.push({
		'event': "previous_page",
		'page': location.pathname,
		'prevLocation': prevLocation ? prevLocation.pathname : null,
		session_interaction_counter: sessionInteractionCounter,
		category_interaction_counter: categoryInteractionCounter,
	});
	window._ss = window._ss || [];
	window._ss.push(['_trackPageView']);
}